import React from "react";
import { Button } from "react-bootstrap";

type Props = {
  analysis: "CAPE" | "Cuckoo" | "FireEye" | "Joe";
  taskId: string | number;
  webServer: string;
  noTrailingSlash?: boolean;
};

const TitleButton: React.FC<Props> = ({
  analysis,
  webServer,
  taskId,
  noTrailingSlash
}) => {
  const handleSeeTaskClick = () => {
    window.open(
      `${webServer}/analysis/${taskId}${noTrailingSlash ? "" : "/"}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <Button
      data-testid={`${analysis.toLowerCase()}-title-button`}
      className="btn btn-primary btn-sm"
      size="sm"
      onClick={handleSeeTaskClick}
    >
      See Task on {analysis}
    </Button>
  );
};

export default TitleButton;
